import React, { useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { CANCELLING_CALL_STATUS, CANCEL_CALL_LABEL, cancelOutgoingRing, getOutgoingRingView, subscribeOutgoingRing } from '../../../interpreter-queue/outgoingRing';
import { readStoredActiveCall } from '../../storedCall';
const useStyles = makeStyles()(() => ({
    root: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        marginTop: 14
    },
    button: {
        background: '#C62828',
        border: 'none',
        borderRadius: 999,
        color: '#FFFFFF',
        cursor: 'pointer',
        font: 'inherit',
        fontSize: 16,
        fontWeight: 700,
        minHeight: 44,
        minWidth: 140,
        padding: '8px 20px',
        '&:disabled': {
            cursor: 'default',
            opacity: 0.7
        },
        '&:focus-visible': {
            outline: '2px solid #FFFFFF',
            outlineOffset: 2
        }
    },
    problem: {
        color: '#FFD9D4',
        fontSize: 14,
        fontWeight: 600,
        lineHeight: 1.45,
        margin: '8px 0 0',
        minHeight: '1.45em',
        textAlign: 'center'
    }
}));
/**
 * "Cancel call" in the partner pane while the ring this page took over from
 * the portal is unanswered (webOutgoingRing.ts; the app:
 * OutgoingRingCancel.native.tsx). The press sends p2p_cancel and reads
 * "Cancelling…" until the server's call_ended closes the room; a refusal or
 * no answer within 10 s is said here, with the button back. Hidden once
 * anyone answers, and after the ring stopped by itself.
 *
 * @returns {JSX.Element|null}
 */
export default function OutgoingRingCancel() {
    const { classes } = useStyles();
    const [ring, setRing] = useState(getOutgoingRingView);
    useEffect(() => {
        setRing(getOutgoingRingView());
        return subscribeOutgoingRing(() => setRing(getOutgoingRingView()));
    }, []);
    if (!ring || ring.callId !== readStoredActiveCall()?.callId || ring.phase === 'stopped') {
        return null;
    }
    const cancelling = ring.phase === 'cancelling';
    return (React.createElement("div", { className: classes.root, "data-outgoing-ring": 'true' },
        React.createElement("button", { "aria-busy": cancelling || undefined, className: classes.button, disabled: cancelling, onClick: cancelOutgoingRing, type: 'button' }, cancelling ? CANCELLING_CALL_STATUS : CANCEL_CALL_LABEL),
        React.createElement("p", { "aria-live": 'polite', className: classes.problem, role: 'status' }, ring.problem || '')));
}
